// this class exists purely to enforce the same structure of a map marker, nothing else
// I wish we used Typescript for this. One day, one day...


export default class Marker {
    mandatoryKeys = [ // having key is mandatory, but the value can still be falsy (i.e. null)
        'geo',
        'picture',
        'station',
        'liheName',
        'maxPromo',
        'pricePerLogement',
        'pricePerPerson',
        'crossedPrice',
        'liheId',
        'productPageUrl',
    ]
    constructor(data) {
        const dataKeysSet = new Set(Object.keys(data))

        this.mandatoryKeys.forEach(key=>{
            if (!dataKeysSet.has(key)) {
                throw new Error(`Not all data provided to map marker. Missing: ${key}`)
            }
        })
        this.geo = data.geo
        this.picture = data.picture
        this.station = data.station
        this.liheName = data.liheName
        this.maxPromo = data.maxPromo
        this.pricePerLogement = data.pricePerLogement
        this.pricePerPerson = data.pricePerPerson
        this.crossedPrice = data.crossedPrice
        this.liheId = data.liheId
        this.productPageUrl = data.productPageUrl
    }
}